// Import lodash.
import _ from 'lodash';
window._ = _;

// Import ramda.
import * as R from 'ramda';
window.R = R;
window.__ = R.__;

// import axios.
import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
